import { render } from "./editCompany.vue?vue&type=template&id=0b1f000a&scoped=true"
import script from "./editCompany.vue?vue&type=script&lang=js"
export * from "./editCompany.vue?vue&type=script&lang=js"

import "./editCompany.vue?vue&type=style&index=0&id=0b1f000a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b1f000a"]])

export default __exports__